import React, {Component} from 'react';
import loginLogo from '../../images/login-logo.png'
import { Link } from 'react-router-dom'
import signupBackground from '../../images/signup-bg.jpg'
import {UserService} from '../../lib/qc-api-client';
import Alert from 'sweetalert-react';
import Utils from '../../lib/utils';
import styled from 'styled-components';
import { Clearfix } from 'react-bootstrap';

const Container = styled.div`
    margin: 0 auto;
    .inner-container {
      width: 1020px;
      margin: auto;
      @media only screen and (max-width: 480px) {
        width: unset;
      }
    }
`

const Logo = styled.div`
  width: 238px;
  margin: 62px auto 100px;
  padding: 0;
  @media only screen and (max-width: 480px) {
    margin: 62px auto 40px;
  }
`

const Login = styled.div`
  width: 515px;
  padding: 85px 80px;
  float: left;
  background-color: #fff;
  h1 {
    width: 100%;
    float: left;
    margin: 0 0 10px;
    padding: 0;
    font-size: 28px;
    color: #39b54a;
    font-weight: 400;
  }
  input {
    border-color: #8290a2;
    height: 45px;
    color: #8290a2;
    margin-bottom: 10px;
  }
  p {
    width: 100%;
    float: left;
    margin: 0;
    padding:0;
    color: #8290a2;
    font-size: 14px;
  }
  .btn {
    width: 100%;
    float: left;
    margin: 0 0 10px;
    background-color: #39b54a;
    color: #fff;
    padding: 12px 0;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    border-radius: 4px;
    WebkitTransition: all .2s ease-in-out;
    OTransition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }
  .social {
    width: 160px;
    float: left;
    margin: 0;
    background-color: #243580;
    color: #fff;
    padding: 15px 0;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    border-radius: 4px;
    @media only screen and (max-width: 480px) {
      width: 100px;
      padding: 12px 0;
    }
  }
  .social-google {
    width: 160px;
    margin: 0;
    background-color: #f20733;
    color: #fff;
    float: right;
    padding: 15px 0;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    border-radius: 4px;
    @media only screen and (max-width: 480px) {
      width: 100px;
      padding: 12px 0;
    }
  }
  @media only screen and (max-width: 480px) {
    margin: 20px 20px 0;
    text-align: center;
    float: unset;
    width: unset;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
`

const SignUpContainer = styled.div`
  width: 505px;
  padding: 120px 65px;
  float: left;
  background: url(${signupBackground}) top left repeat-y #39b54a;
  margin-top: 30px;
  h1 {
    width: 100%;
    float: left;
    margin: 0;
    padding: 0;
    color: #fff;
    font-size: 28px;
    font-weight: 400;
  }
  p {
    width: 100%;
    float: left;
    margin: 20px 0;
    padding: 0;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
  }
  .signup-btn {
    width: 145px;
    float: left;
    margin: 0;
    background-color: #0071bc;
    color: #fff;
    padding: 12px 0;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    border-radius: 4px;
    transition: all .2s ease-in-out;
    @media only screen and (max-width: 480px) {
      width: 100px;
      padding: 12px 0;
    }
  }
  .employers-btn {
    float: left;
    padding: 14px 20px 12px;
    transition: all .2s ease-in-out;
    @media only screen and (max-width: 480px) {
      width: 140px;
      padding: 14px 10px 12px;
    }
  }
  @media only screen and (max-width: 480px) {
    margin: 0 20px 20px;
    float: unset;
    width: 515px;
    padding: 65px;
    width: unset;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`

export default class SignUp extends Component {

    constructor(props) {
      super(props)
      this.state = {
        email: ''
      }
    }

    componentWillMount() {
      window.scrollTo(0,0);
    }

    onKeyDown = (event) => {
      if (event.key === 'Enter') {
        this.handleSignIn();
      }
    }

    handleSignIn = () => {
      UserService.signIn(this.state.email, this.state.password)
        .then((response) => {
          const user = response.data.user;
          Utils.setUserToken(response.data.token)
          this.setState({
            user: user,
            showLoginAlert: true,
            alertType: 'success',
            alertMessage: 'Welcome back!'
          });

          var promise = new Promise(resolve => setTimeout(resolve, 3000));

          promise.then(response => {
            this.setState({showLoginAlert: false})
            if (this.props.location.redirect) {
              this.props.history.push(this.props.location.redirect)
            }
            else if (user.role === 'employer') {
		          window.location.href='/dashboard/jobs';
            } else {
		          window.location.href='/jobs';
            }
          })
        })
        .catch((error) => {
          this.setState({
            showLoginAlert: true,
            alertType: 'error',
            alertMessage: error.response?.data?.message,
          });
        })
    }

    handleChange = (event) => {
      let name = event.target.name;
      let value = event.target.value
      this.setState({ [name]: value })
    }

    render() {
        return (
          <Container>
          <div className="inner-container">
            <Logo>
              <a href="/"><img src={loginLogo} alt=""/></a>
            </Logo>
            <Login>
              <h1>Sign in</h1>
              <form name="usersignin">
                <input
                  type="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  onKeyDown={this.onKeyDown}
                  className="form-control"
                  name="email"
                  placeholder="Email"
                  required
                />
                <input
                  type="password"
                  onChange={this.handleChange}
                  onKeyDown={this.onKeyDown}
                  className="form-control"
                  name="password"
                  placeholder="Password"
                  required
                />
                <input type="button" onClick={this.handleSignIn} className="btn_signin btn" value="Sign In"/>
              </form>

              <Link to="/forgot-password" style={{color: '#fff'}}><p>Forgot your password?</p></Link>
              <div style={{margin: '40px 0', display: 'block'}}>&nbsp;</div>
            </Login>
            <SignUpContainer>
              <h1>Sign up</h1>
              <p>Looking for a new career move. Look no further. Sign up now and engage with the employers using our platform.</p>
              <Link className="signup-btn" to="/register">Sign Up</Link>
              <div className="employers-btn">
                <Link to="/employers/post-job" style={{color: '#fff'}}>
                  Employers Sign Up
                </Link>
              </div>
              <Clearfix />
            </SignUpContainer>
            <Clearfix />
          </div>
            <Alert
              show={this.state.showLoginAlert}
              title="Login"
              text={this.state.alertMessage}
              // text="Welcome aboard!"
              type={this.state.alertType}
              onConfirm={() => this.setState({ showLoginAlert: false })}
            />
          </Container>
        )
    }
}
